import { NavLink } from "react-router-dom";

export default function SectionVehicle3({ _data }) {
  return (
    <div className="section-full  p-b90 site-bg-gray tw-service-gallery-style4-area tyre-mark-bg">
      <div className="services-gallery-block-outer2">
        <div className="container">
          {/* TITLE START*/}
          <div className="section-head center wt-small-separator-outer">
            <div className="wt-small-separator site-text-primary">
              <div>{_data.title}</div>
            </div>
            <h2 className="wt-title">{_data.subtitle}</h2>
          </div>
          {/* TITLE END*/}

          <div className="section-content">
            <div className="services-gallery-style4">
              <div className="owl-carousel services-gallery-four owl-btn-bottom-center">
                {_data.vehicles.map((_object, index) => (
                  <div key={index} className="item">
                    <div className="service-box-style4 shadow-sm p-3 rounded">
                      <div className="service-content-inner text-center">
                        {/* Vehicle Title */}

                        {/* Vehicle Image */}
                        <img
                          src={_object.image}
                          alt={_object.title}
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            marginBottom: "15px",
                          }}
                        />

                        {_object.title && (
                          <h3 className="text-lg font-semibold text-gray-800 text-center mb-2">
                            <NavLink to="/services/service2">
                              {_object.title}
                            </NavLink>
                          </h3>
                        )}

                        {/* Vehicle Specs - compact grid */}
                        {_object.specs && (
                          <div className="flex flex-col items-center text-sm text-gray-700 gap-2">
                            {/* First row: Length, Height, Width */}
                            <div className="flex gap-6">
                              {["Length", "Height", "Width"].map((label) => {
                                const spec = _object.specs.find(
                                  (s) => s.label === label
                                );
                                return spec ? (
                                  <span key={label} className="px-1">
                                    {spec.label}: {spec.value}
                                  </span>
                                ) : null;
                              })}
                            </div>

                            {/* Second row: Range, Weight Capacity */}
                            <div className="flex gap-6">
                              {["Range", "Weight Capacity"].map((label) => {
                                const spec = _object.specs.find(
                                  (s) => s.label === label
                                );
                                return spec ? (
                                  <span key={label} className="px-1">
                                    {spec.label}: {spec.value}
                                  </span>
                                ) : null;
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="tw-hilite-text-wrap">
        <div className="tw-hilite-text right">
          <span>Fleets</span>
        </div>
      </div>
    </div>
  );
}
